import { css, SerializedStyles } from '@emotion/react';
import styled from '@emotion/styled';
import { EmotionTheme } from 'src/domains/layouts/config/emotionTheme';
import { DefaultComponentVariantType } from 'src/domains/layouts/config/features/types';
import { withConfig } from 'src/withConfig';

interface GoalscorerMarketGroupPropsType {
    variant: DefaultComponentVariantType | null;
}

export const MarketGroupFilters = withConfig(theme => styled('nav', { label: 'MarketGroupFilters' })<GoalscorerMarketGroupPropsType>`
    background-color: ${theme.star.marketGroupGoalscorer.bgColorSecondary};
    margin-top: -1px;
    padding: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? `${theme.star.padding.medium} 0` : theme.star.padding.medium};
`);

export const SelectionsGroupWrap = withConfig(theme => styled('div', { label: 'SelectionsGroupWrap' })<GoalscorerMarketGroupPropsType>`
    background-color: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? 'transparent' : theme.star.selection.bgColor};
    display: flex;
    flex-flow: column nowrap;
    margin-bottom: -1px;
`);

export const SelectionsInRow = styled('ul', { label: 'SelectionsInRow' })`
    display: flex;
`;

const setMarketGroupCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            margin: 4px 0;
        `;
    }
    return css`
        border-bottom: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};
        border-top: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};
        margin-bottom: -1px;
    `;
};

export const MarketGroupCaption = withConfig(theme => styled('div', { label: 'MarketGroupCaption' })<GoalscorerMarketGroupPropsType>`
    ${({ variant }): SerializedStyles => setMarketGroupCaption(variant, theme)}
    align-items: center;
    display: flex;
    justify-content: space-between;
    line-height: 1.4;
    position: relative;
    width: 100%;
`);

const setCaptionGroup = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.small};
            margin-right: 4px;
        `;
    }
    return css``;
};

export const CaptionGroup = withConfig(theme => styled('div', { label: 'CaptionGroup' })<GoalscorerMarketGroupPropsType>`
    ${({ variant }): SerializedStyles => setCaptionGroup(variant, theme)}
    display: flex;
`);

interface CaptionPropsType {
    isFirst?: boolean;
    variant: DefaultComponentVariantType | null;
}

const setCaption = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css``;
    }
    return css`
        border-left: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};
        border-right: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};
    `;
};

export const Caption = withConfig(theme => styled('span', { label: 'Caption' }) <CaptionPropsType>`
    ${({ variant }): SerializedStyles => setCaption(variant, theme)}
    color: ${theme.star.marketGroupGoalscorer.txtColor};
    font-size: ${theme.star.fontSize.xSmall};
    margin-left: -1px;
    padding-left: ${({ isFirst }): string => isFirst === true ? '8px' : '0'};
    text-align: ${({ isFirst }): string => isFirst === true ? 'left' : 'center'};
    width: ${({ isFirst }): string => isFirst === true ? '100%' : '50px'};
    @media ${theme.star.mediaQuery.tablet} {
        width: ${({ isFirst }): string => isFirst === true ? '100%' : '68px'};
    }
`);

interface SelectionsGroupPropsType {
    variant: DefaultComponentVariantType | null;
}

export const SelectionsGroup = withConfig(theme => styled('section', { label: 'SelectionsGroup' })<SelectionsGroupPropsType>`
    display: flex;
    justify-content: center;
    width: 100%;
    gap: ${({ variant }): string => variant === DefaultComponentVariantType.SECONDARY ? theme.star.gap.small : '0'};
`);

const setGoalscorers = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            gap: ${theme.star.gap.small};
        `;
    }
    return css`
        border-top: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};
    `;
};

export const Goalscorers = withConfig(theme => styled('ul', { label: 'Goalscorers' })<GoalscorerMarketGroupPropsType>`
    ${({ variant }): SerializedStyles => setGoalscorers(variant, theme)}
    display: flex;
    flex-flow: column nowrap;
    width: 100%;
`);

export const GoalscorersElement = withConfig(theme => styled('li', { label: 'GoalscorersElement' })`
    border-right: 0;
    display: flex;
    flex-flow: row nowrap;
    flex: 1 0 0%;
    justify-content: space-between;
    width: 100%;
    min-height: 40px;
    &.market-group__goalscorers--NG .selection {
        background: ${theme.star.marketGroupGoalscorer.bgColorTertiary};
    }
`);

interface GoalscorerNamePropsType {
    templateId: string;
    variant: DefaultComponentVariantType | null;
}

const setGoalscorerName = (variant: DefaultComponentVariantType | null, theme: EmotionTheme): SerializedStyles => {
    if (variant === DefaultComponentVariantType.SECONDARY) {
        return css`
            display: flex;
            align-items: center;
        `;
    }
    return css`
        display: block;
        border-bottom: 1px solid ${theme.star.marketGroupGoalscorer.borderColor};
    `;
};

export const GoalscorerName = withConfig(theme => styled('span', { label: 'GoalscorerName' })<GoalscorerNamePropsType>`
    ${({ variant }): SerializedStyles => setGoalscorerName(variant, theme)}
    background: ${({ templateId }): string => templateId === 'NG' ? theme.star.marketGroupGoalscorer.bgColorTertiary : 'transparent'};
    color: ${theme.star.selectionsGroup.txtColor};
    line-height: 1.3334;
    overflow: hidden;
    padding: 13px 8px 11px;
    text-overflow: ellipsis;
    white-space: nowrap;
    width: 100%;
`);
